import { useQuery } from '@tanstack/react-query';
import { onboardingApis } from './api';

/** GET /onboarding/status - gate with `enabled` to Clinic Owner sessions only (403 otherwise). */
const useOnboardingStatus = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ['onboarding', 'status'],
    queryFn: () => onboardingApis.getOnboardingStatus(),
    enabled,
    retry: false,
  });

export const onboardingQueries = { useOnboardingStatus };
